// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"66a2c31f","132":"25e26b47","188":"50fe0156","198":"684c4ece","393":"1c7ca7ac","549":"0094584a","601":"a317bb8d","729":"c2364bba","929":"bdd689bf","939":"9c0628e6","940":"4fd68260"}[chunkId] + ".chunk.css";
};